import React from 'react';
import { ModalOverlay as OmModalOverlay, ModalOverlayProps as OmModalOverlayProps } from '@moda/om';
import { getModalShards } from './getModalShards';

export type ModalOverlayProps = OmModalOverlayProps;

export const ModalOverlay: React.FC<ModalOverlayProps> = ({ shards, ...rest }) => (
  <OmModalOverlay shards={[...getModalShards(), ...(shards ?? [])]} {...rest} />
);
